import { render, staticRenderFns } from "./BtnReadMore.vue?vue&type=template&id=54171b8c&lang=pug&"
import script from "./BtnReadMore.vue?vue&type=script&lang=js&"
export * from "./BtnReadMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports